import React from 'react'
import { ErrorContainer, ErrorMessage, ErrorTip } from '../style'

const WithoutSelectedFields:React.FC<{dropdown:React.Dispatch<React.SetStateAction<boolean>>}> = ({dropdown}) => {
  return (
    <ErrorContainer>
      <ErrorMessage>Nenhum campo da tabela selecionado</ErrorMessage>
      <p><ErrorTip onClick={() => dropdown(true)}>Clique aqui</ErrorTip> para selecionar um campo.</p>
    </ErrorContainer>
  )
}

export default WithoutSelectedFields